// https://stackoverflow.com/a/25490531
export const getCookie = (name: string): string =>
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
